import { cn } from '@/ui/lib/utils';
import './spinner.css';

interface SpinnerProps {
    size?: 'sm' | 'md' | 'lg';
    className?: string;
}

export const Spinner = ({ size = 'md', className }: SpinnerProps) => {
    return <div className={cn('spinner', `spinner--${size}`, className)}></div>;
};
